/* eslint-disable array-callback-return */
import React, { useEffect, useRef, useState } from "react";
import PowerPositionCard from "../../../components/PowerPositionCard/powerPositionCard";
import SuperiorImg from "../../../assets/Images/Mighty.png";
import DependentPartnerImg from "../../../assets/Images/DependentPartners.png";
import IndependentPartnerImg from "../../../assets/Images/IndependentPartners.png";
import InferiorImg from "../../../assets/Images/Weak.png";
import WarningMsgIcon from "../../../assets/Icons/WarningIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/Reducer";
import {
  getAISuggestionForPowerPosition,
  getPowerPositionList,
  savePowerPosition,
} from "../../../redux/Action/Action";
import setClasssificationIcon from "../../../assets/Icons/SetClassificationIcon.svg";
import PowerPositionQuestionnaire from "./powerPositionQuestionnaire";
import Buttons from "../../../components/Buttons/Buttons";
import {
  POST_SAVE_FORM_DETAILS,
  SET_POWER_POSITION,
  SET_POWER_POSITION_ID,
} from "../../../redux/Action/actionTypes";
import { FormikProps } from "formik";

interface Props {
  currentStep: number;
  totalSteps: number;
  goNext: () => void;
  goBack: () => void;
  isNextDisabled: boolean;
  isDetailedOverview?: boolean;
}
interface FormValues {
  supplierExistOrNot: string;
  supplierAwareness: string;
  supplierDependent: string;
}

const PowerPositionComponent = ({
  currentStep,
  totalSteps,
  goNext,
  goBack,
  isNextDisabled,
  isDetailedOverview = false
}: Props) => {
  const dispatch = useDispatch();
  const [isShowClassification, setIsShowClassification] =
    useState<boolean>(false);
  const formikRef = useRef<FormikProps<FormValues | null>>(null);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState<boolean>(true);
  const [cardSelected, setCardSelected] = useState<string>("");
  const [showAIRecommendation, setShowAIRecommendation] =
    useState<boolean>(false);

  const powerPositionListArr = useSelector((state: RootState) => state.powerPosition.powerPositionListData)
  const aiPowerPositionData = useSelector(
    (state: RootState) => state.powerPosition.aiPowerPositionData
  );
  const basicDetailsData = useSelector(
    (state: RootState) => state.basicDetails
  );
  const powerPositionDetails = useSelector(
    (state: RootState) => state.powerPosition
  );
  const TargetValuenData = useSelector(
    (state: RootState) => state.TargetValue.TargetValueData
  );
  const salesRepClassificationData = useSelector(
    (state: RootState) => state.salesRepClassification
  );
  const isFormUpdate = useSelector(
    (state: RootState) => state.basicDetails.formState
  );

  // power postion card contente handler for different power position 
  const userContentHandler = (userName: string) => {
    switch (userName) {
      case "Superior":
        return (
          <ul>
            <li>
              <b>Supplier is more dependant</b> on you as a client than you are on the supplier.
            </li>
            <li>
              Your objective must be <b>very ambitious</b> and should beat the
              price change of the supplier’s input products (e.g. precursors)
              significantly
            </li>
          </ul>
        );
      case "Dependent":
        return (
          <ul>
            <li>
              Both you and the supplier are <b>dependant on each other.</b>
            </li>
            <li>
              Your objective must be <b>ambitious</b> and should{" "}
              <b>beat the price change</b> of the supplier’s (e.g. precursors)
            </li>
          </ul>
        );
      case "Independent":
        return (
          <ul>
            <li>Neither you nor the supplier are dependent on each other</li>
            <li>
              Your objective should <b>beat the price change</b> of the
              supplier’s input products (e.g. precursors), without any price
              premium for the supplier
            </li>
          </ul>
        );
      case "Inferior":
        return (
          <ul>
            <li>
              <b>You are more dependent</b> on the supplier than the supplier is on you.
            </li>
            <li>
              Your objective should be <b>oriented toward the price change</b>{" "}
              of the supplier’s input products (e.g. precursors); negotiating
              results worse than price change must be avoided
            </li>
          </ul>
        );
    }
  };

  // getting supplier name for power position header text
  let supplierName = "";
  basicDetailsData.suppliersData.map((obj: any) => {
    if (obj?.value === basicDetailsData.basicDetailsData.suppliers) {
      supplierName = obj?.name;
    }
  });

  // calling this method on click of check AI recommendation button 
  const aiSuggestionHandler = () => {
    let payload = {
      Category: "",
      RequestSource: "PowerPosition",
      Supplier: "",
    };
    let basicDetails = basicDetailsData.basicDetailsData;

    basicDetailsData.catagoriesData.map((obj: any) => {
      if (obj?.value === basicDetails.categoryName) {
        payload.Category = obj?.name;
      }
    });
    basicDetailsData.suppliersData.map((obj: any) => {
      if (obj?.value === basicDetails.suppliers) {
        payload.Supplier = obj?.name;
        supplierName = obj?.name;
      }
    });
    dispatch(getAISuggestionForPowerPosition(payload));
  };

  // updating power position id after selection 
  const powerPositionIdHandler = (titleName: string) => {
    let selectedCardId: any = ""
    powerPositionListArr.length > 0 && powerPositionListArr.map((obj: any) => {
      if (obj.title === titleName) {
        selectedCardId = obj.id
      }
    })
    dispatch({ type: SET_POWER_POSITION_ID, payload: selectedCardId });
  }

  // saving power position after selected the card 
  const powerPositionTypeOnSave = (typeName: string) => {
    if (typeName === cardSelected) {
      setCardSelected("");
      dispatch({ type: SET_POWER_POSITION, payload: "" });
    } else {
      setCardSelected(typeName);
      dispatch({ type: SET_POWER_POSITION, payload: typeName });
    }
    powerPositionIdHandler(typeName)
  };

  // updating power postion card selection after the AI api resonpse 
  useEffect(() => {
    if (
      Object.keys(aiPowerPositionData).length > 0 &&
      ["Superior", "Dependent", "Independent", "Inferior", null].includes(
        aiPowerPositionData?.powerPosition
      )
    ) {
      setShowAIRecommendation(true);
      powerPositionIdHandler(aiPowerPositionData?.powerPosition)
    }
  }, [aiPowerPositionData]);

  // toggle handler for showing the classification question page 
  const toggleHandler = () => setIsShowClassification(!isShowClassification);

  // save api method for save as draft method 
  const saveHandler = () => {
    isShowClassification &&
      dispatch(savePowerPosition(formikRef?.current?.values));
    dispatch({
      type: POST_SAVE_FORM_DETAILS,
      payload: {
        basicDetailsData: basicDetailsData.basicDetailsData,
        powerPositionDetails,
        salesRepClassificationData,
        TargetValuenData,
        isFormUpdate,
      },
    });
  };

  // submit handler for submit button 
  const submitHandler = () => {
    setIsShowClassification(false);
    setShowAIRecommendation(false)
    if (formikRef.current) {
      formikRef.current.submitForm();
    }
  };

  // updating the card selection after get api response 
  useEffect(() => {
    if (
      powerPositionDetails.powerPosition !== "" &&
      powerPositionDetails.powerPosition !== null
    ) {
      setCardSelected(powerPositionDetails.powerPosition);
    }
  }, [powerPositionDetails]);

  const card1Ref = useRef<HTMLDivElement | null>(null);
  const card2Ref = useRef<HTMLDivElement | null>(null);
  const card3Ref = useRef<HTMLDivElement | null>(null);
  const card4Ref = useRef<HTMLDivElement | null>(null);

  // adjusting the heights of power position card 
  const syncHeights = () => {
    let cardRefs = [card1Ref, card2Ref, card3Ref, card4Ref]
    // Reset heights
    cardRefs.forEach(ref => {
      if (ref.current) ref.current.style.minHeight = '470px';
    });

    // Calculate max height
    const maxHeight = Math.max(
      ...cardRefs.map(ref => ref.current?.offsetHeight || 0)
    );

    // Apply max height
    cardRefs.forEach(ref => {
      if (ref.current) ref.current.style.minHeight = `${maxHeight}px`;
    });
  };

  useEffect(() => {
    syncHeights();
    window.addEventListener('resize', syncHeights);
    return () => window.removeEventListener('resize', syncHeights);
  }, []);

  // calling power position list api of id for updating the power position id 
  useEffect(() => {
    if (powerPositionListArr.length == 0) {
      dispatch(getPowerPositionList());
    }
  }, [])

  return (
    <>
      {isShowClassification ? (
        <PowerPositionQuestionnaire
          setIsSubmitDisabled={setIsSubmitDisabled}
          setRefInstance={(instance: any) => (formikRef.current = instance)}
          powerPositionIdHandler={powerPositionIdHandler}
        />
      ) : (
        <div className="powerPositionContainer">
          {isDetailedOverview ? null:<>
          <div className="power-position-header ">
            Determine the <u>power position </u>of yourselfs in this negotiation with
            the supplier <em>"{supplierName}"</em>.
          </div>
          <div className="row">
            <div className="col-lg-3 col-md-6 offset-lg-3 offset-md-0 col-sm-6">
              <button
                  className="set-classification-box"
                  onClick={toggleHandler}
                  type="button"
                  style={{ background: "none", width: "100%" }}
                >
                  <img
                  src={setClasssificationIcon}
                  alt="Set Classification Icon"
                  />
                  <div className="set-classification-box-text">
                    Set Power Position
                  </div>
                </button>
              </div>
              <div
                className="col-lg-3 col-md-6 col-sm-6"
                onClick={aiSuggestionHandler}
                role="button"
              >
                <div className="ai-suggestion-box">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="#FFF"
                    className="bi bi-magic"
                    viewBox="0 0 16 16"
                  >
                    <path d="M9.5 2.672a.5.5 0 1 0 1 0V.843a.5.5 0 0 0-1 0zm4.5.035A.5.5 0 0 0 13.293 2L12 3.293a.5.5 0 1 0 .707.707zM7.293 4A.5.5 0 1 0 8 3.293L6.707 2A.5.5 0 0 0 6 2.707zm-.621 2.5a.5.5 0 1 0 0-1H4.843a.5.5 0 1 0 0 1zm8.485 0a.5.5 0 1 0 0-1h-1.829a.5.5 0 0 0 0 1zM13.293 10A.5.5 0 1 0 14 9.293L12.707 8a.5.5 0 1 0-.707.707zM9.5 11.157a.5.5 0 0 0 1 0V9.328a.5.5 0 0 0-1 0zm1.854-5.097a.5.5 0 0 0 0-.706l-.708-.708a.5.5 0 0 0-.707 0L8.646 5.94a.5.5 0 0 0 0 .707l.708.708a.5.5 0 0 0 .707 0l1.293-1.293Zm-3 3a.5.5 0 0 0 0-.706l-.708-.708a.5.5 0 0 0-.707 0L.646 13.94a.5.5 0 0 0 0 .707l.708.708a.5.5 0 0 0 .707 0z" />
                  </svg>
                  <div className="ai-suggestion-text">
                    Check AI Recommendation
                  </div>
                </div>
              </div>
            </div></>}
          {showAIRecommendation && (
            <div className="row align-items-stretch ai-recommendation-text-box">
              <div className="col-md-1">
                <img
                  src={WarningMsgIcon}
                  width="40px"
                  height="40px"
                  alt="Warning icon"
                />
              </div>
              <div className="col-md-10 col-sm-12 ai-recommendation-content">
                {aiPowerPositionData?.response ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: aiPowerPositionData.response,
                    }}
                  />
                ) : null}
              </div>
              <div className="col-md-1">
                <svg
                  onClick={() => setShowAIRecommendation(false)}
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="#EA9516"
                  className="bi bi-x-lg"
                  viewBox="0 0 16 16"
                >
                  <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                </svg>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-sm-8 pl-0 offset-sm-2 offset-md-0 col-md-6 col-lg-3 ">
              <PowerPositionCard
                userName="Superior"
                userContent={<>{userContentHandler("Superior")}</>}
                userImage={SuperiorImg}
                cardSelected={cardSelected}
                cardHandler={() => powerPositionTypeOnSave("Superior")}
                ref={card1Ref}
              />
            </div>
            <div className="col-sm-8 offset-sm-2 offset-md-0 col-md-6 col-lg-3 ">
              <PowerPositionCard
                userName="Independent"
                userContent={<>{userContentHandler("Independent")}</>}
                userImage={IndependentPartnerImg}
                cardSelected={cardSelected}
                cardHandler={() => powerPositionTypeOnSave("Independent")}
                ref={card2Ref}
              />
            </div>
            <div className="col-sm-8 offset-sm-2 offset-md-0 col-md-6 col-lg-3 ">
              <PowerPositionCard
                userName="Dependent"
                userContent={<>{userContentHandler("Dependent")}</>}
                userImage={DependentPartnerImg}
                cardSelected={cardSelected}
                cardHandler={() => powerPositionTypeOnSave("Dependent")}
                ref={card3Ref}
              />
            </div>
            <div className="col-sm-8 offset-sm-2 offset-md-0 col-md-6 col-lg-3 ">
              <PowerPositionCard
                userName="Inferior"
                userContent={<>{userContentHandler("Inferior")}</>}
                userImage={InferiorImg}
                cardSelected={cardSelected}
                cardHandler={() => powerPositionTypeOnSave("Inferior")}
                ref={card4Ref}
              />
            </div>
          </div>
        </div>
      )}
      {isDetailedOverview ? null :
        <Buttons
          currentStep={currentStep}
          totalSteps={totalSteps}
          goNext={goNext}
          goBack={goBack}
          isNextDisabled={
            !(
              powerPositionDetails?.powerPosition !== "" &&
              powerPositionDetails?.powerPosition != null
            )
          }
          isShowClassification={isShowClassification}
          setIsShowClassification={setIsShowClassification}
          submitHandler={submitHandler}
          isSubmitDisabled={isSubmitDisabled}
          saveHandler={saveHandler}
        />}
    </>
  );
};

export default PowerPositionComponent;
